<template>
  <Modal
    v-model="_value"
    width="900"
    title="查看/修改安装订单"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
<!--    <div style="position:relative;">-->
      <Tabs type="card">
        <TabPane label="必要订单信息">
          <Form :model="installOrder" :rules="rules" :label-width="90">
            <Row>
              <Col span="8">
                <FormItem prop="registrationNum" label="车牌号码">
                  <Input :disabled="!modify" class="field" search v-model="installOrder.tempVehicleInfo.registrationNum" placeholder="请输入车牌号码">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="name" label="车牌颜色">
                  <Select :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.registrationColor">
                    <Option v-for="item in registrationColorOptions" :value="item.value" :key="item.value">
                      {{item.label}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vin" label="车架号">
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.vin" placeholder="请输入车架号">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="totalAmount"label="应收总金额">
                  <InputNumber :disabled="!modify" :min="0" class="field" v-model="installOrder.totalAmount" placeholder="请输入应收总金额"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="serviceDatetime" label="服务到期时间">
                  <DatePicker :disabled="!modify" type="date" v-model="installOrder.serviceDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="businessType" label="业务类型">
                  <Select :disabled="!modify" class="field" v-model="installOrder.businessType">
                    <Option v-for="item in installOrderBusinessType" :value="item.value" :key="item.value">{{item.label}}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="engineNum" label="发动机号">
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.engineNum" placeholder="请输入发动机号">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleTypeName" label="车辆类型">
                  <Select :disabled="!modify"
                    placeholder="请输入车辆类型名称"
                    v-model="installOrder.tempVehicleInfo.vehicleType.name"
                    filterable
                    remote
                    :remote-method="searchVehicleType"
                    :loading="searchVehicleTypeLoading"
                    class="field"
                    clearable>
                    <Option v-for="(option, index) in searchVehicleTypeList" :value="option.name" :key="option.name">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="businessUserId" label="跟进业务员">
                  <Select :disabled="!modify" class="field" v-model="installOrder.businessUserId">
                    <Option v-for="item in businessUsers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName != null?item.realName:item.nickName != null?item.nickName:item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="qghyptOption" label="全国货运平台">
                  <Select :disabled="!modify" class="field" v-model="installOrder.qghyptOption">
                    <Option v-for="item in qghyptOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="billType" label="开票类型">
                  <Select :disabled="!modify" class="field" v-model="installOrder.billType">
                    <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="isfree" label="订单类型">
                  <Select :disabled="!modify"  class="field" v-model="installOrder.isfree">
                    <Option v-for="item in orderTypeOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col v-if="installOrder.isfree != 1" span="8">
                <FormItem prop="mliftainsuranceChannelId" label="交强险公司">
                  <Select  :disabled="!modify"
                    placeholder="请选择交强险公司"
                    v-model="installOrder.tempVehicleInfo.mliftainsuranceChannelId"
                    filterable
                    remote
                    :remote-method="searchMLIFTAinsuranceChannel"
                    :loading="searchMLIFTAinsuranceChannelLoading"
                    class="field" style="width: 70%;"
                    clearable>
                    <Option v-for="(option, index) in searchMLIFTAinsuranceChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col v-if="installOrder.isfree != 1" span="8">
                <FormItem prop="tiinsuranceChannelId" label="商业险公司">
                  <Select  :disabled="!modify"
                    placeholder="请选择商业险公司"
                    v-model="installOrder.tempVehicleInfo.tiinsuranceChannelId"
                    filterable
                    remote
                    :remote-method="searchTIinsuranceChannel"
                    :loading="searchTIinsuranceChannelLoading"
                    class="field" style="width: 70%;"
                    clearable>
                    <Option v-for="(option, index) in searchTIinsuranceChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col v-if="installOrder.isfree != 1" span="8">
                <FormItem prop="insured" label="车主/受保人">
                  <Input class="field" :disabled="!modify" v-model="installOrder.tempVehicleInfo.insured" placeholder="请输入车主/受保人"></Input>
                </FormItem>
              </Col>
              <Col v-if="installOrder.isfree != 1" span="8">
                <FormItem prop="mliftainsurancechannelDatetime">
                  <label>交强险到期日</label>
                  <DatePicker type="date"  :disabled="!modify" v-model="installOrder.tempVehicleInfo.mliftainsurancechannelDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
              <Col v-if="installOrder.isfree != 1" span="8">
                <FormItem prop="tiinsurancechannelDatetime" label="商业险到期日">
                  <DatePicker type="date"  :disabled="!modify" v-model="installOrder.tempVehicleInfo.tiinsurancechannelDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="businessUserId" label="是否已收款">
                  <RadioGroup v-model="installOrder.receptDatetime">
                    <Radio :disabled="!modify" label="是"></Radio>
                    <Radio :disabled="!modify" label="否"></Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="qghyptOption" label="是否加急">
                  <Space direction="vertical" size="large">
                    <RadioGroup v-model="installOrder.urgent">
                      <Radio :disabled="!modify" label="是"></Radio>
                      <Radio :disabled="!modify" label="否"></Radio>
                    </RadioGroup>
                  </Space>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="businessUserId" label="预约安装时间">
                  <DatePicker :disabled="!modify" type="datetime" v-model="installOrder.bookingDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
              <Col span="16">
                <FormItem prop="qghyptOption" label="预约安装地点">
                  <Input :disabled="!modify" class="field" v-model="installOrder.bookingPlace">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem prop="clientInfoId" label="客户信息">
                  <Select :disabled="!modify"
                    placeholder="请选择客户名称"
                    v-model="installOrder.clientInfoId"
                    filterable
                    remote
                    :remote-method="searchClientInfo"
                    :loading="searchClientInfoLoading"
                    class="field" style="width: 60%;"
                    clearable>
                    <Option v-for="(option, index) in searchClientInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoBtn">添加客户信息</Button>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="vehicleOwnerInfoId" label="车辆所有人信息">
                  <Select :disabled="!modify"
                    placeholder="请选择车辆所有人名称"
                    v-model="installOrder.tempVehicleInfo.vehicleOwnerInfoId"
                    filterable
                    remote
                    :remote-method="searchVehicleOwnerInfo"
                    :loading="searchVehicleOwnerInfoLoading"
                    class="field" style="width: 60%;"
                    clearable>
                    <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddVehicleOwnerInfoBtn">添加所有人</Button>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem prop="vehicleInfoGroupId" label="预绑定车辆分组">
                  <Select :disabled="!modify"
                    placeholder="请选择车辆分组名称"
                    v-model="installOrder.vehicleInfoGroupId"
                    filterable
                    remote
                    :remote-method="searchVehicleInfoGroup"
                    :loading="searchVehicleInfoGroupLoading"
                    class="field" style="width: 60%;"
                    clearable placement="top">
                    <Option v-for="(option, index) in searchVehicleInfoGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoGroupBtn">添加车辆分组</Button>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="salesChannelId" label="销售渠道">
                  <Select :disabled="!modify"
                          placeholder="请选择销售渠道"
                          v-model="installOrder.salesChannelId"
                          filterable
                          remote
                          :remote-method="searchSalesChannel"
                          :loading="searchSalesChannelLoading"
                          class="field" style="width: 60%;"
                          clearable placement="top">
                    <Option v-for="(option, index) in searchSalesChannelList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddsearchSalesBtn">添加销售渠道</Button>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem :disabled="!modify" prop="attention" label="重点关注">
                  <Checkbox v-model="installOrder.tempVehicleInfo.attention"></Checkbox>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="businessUserId" label="安装维修员">
                  <Select :disabled="!modify" class="field" v-model="installOrder.installerId">
                    <Option v-for="item in installers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName===null?item.name==null?item.nickName:item.name:item.realName}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleInfoGroup" label="车辆识别码">
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.identificationCode" placeholder="请输入车辆识别码">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem prop="orderRemark" label="订单备注">
                  <Input :disabled="!modify" class="field" style="width: 80%;" v-model="installOrder.remark" type="textarea">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem prop="history" label="历史记录">
                  <Input :disabled="true" class="field" style="width: 80%;" v-model="installOrder.history" type="textarea">
                  </Input>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </TabPane>
        <TabPane label="车辆基本信息">
          <Form ref="loginForm" :model="installOrder.tempVehicleInfo" :rules="rules">
            <Row>
              <Col span="8">
                <FormItem prop="registrationNum">
                  <label>自定义名称</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.customName" placeholder="请输入自定义名称">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleTypeName">
                  <label>车辆类型</label>
                  <Select :disabled="!modify"
                          placeholder="请输入车辆类型名称"
                          v-model="installOrder.tempVehicleInfo.vehicleType.name"
                          filterable
                          remote
                          :remote-method="searchVehicleType"
                          :loading="searchVehicleTypeLoading"
                          class="field"
                          clearable>
                    <Option v-for="(option, index) in searchVehicleTypeList" :value="option.name" :key="option.name">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleBrandName">
                  <label>车辆品牌</label>
                  <Select :disabled="!modify"
                          placeholder="请输入车辆品牌名称"
                          v-model="installOrder.tempVehicleInfo.vehicleBrand.name"
                          filterable
                          remote
                          :remote-method="searchVehicleBrand"
                          :loading="searchVehicleBrandLoading"
                          class="field"
                          clearable>
                    <Option v-for="(option, index) in searchVehicleBrandList" :value="option.name" :key="option.name">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="bodyColor">
                  <label>车身颜色</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.bodyColor" placeholder="请输入车身颜色">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="engineNum">
                  <label>发动机号</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.engineNum" placeholder="请输入发动机号">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleLicenseNum">
                  <label>行驶证号</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.vehicleLicenseNum" placeholder="请输入行驶证号">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="unladenMass">
                  <label>整备质量(kg)</label>
                  <InputNumber :disabled="!modify" class="field" :min="0" v-model="installOrder.tempVehicleInfo.unladenMass"
                               placeholder="请输入整备质量"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="engineNum">
                  <label>核准载重(kg)</label>
                  <InputNumber :disabled="!modify" class="field" :min="0" v-model="installOrder.tempVehicleInfo.approvedLoad"
                               placeholder="请输入核准载重"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleUse">
                  <label>使用性质</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.vehicleUse" placeholder="请输入使用性质">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem prop="vehicleOwnerInfoId">
                  <label>车辆所有人信息</label>
                  <Select :disabled="!modify"
                          placeholder="请选择车辆所有人名称"
                          v-model="installOrder.tempVehicleInfo.vehicleOwnerInfoId"
                          filterable
                          remote
                          :remote-method="searchVehicleOwnerInfo"
                          :loading="searchVehicleOwnerInfoLoading"
                          class="field" style="width: 80%;"
                          clearable>
                    <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddVehicleOwnerInfoBtn">添加所有人</Button>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem prop="remark">
                  <label>备注</label>
                  <Input :disabled="!modify" class="field" style="width: 80%;" v-model="installOrder.tempVehicleInfo.remark" type="textarea"
                         placeholder="请输入备注">
                  </Input>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </TabPane>
        <TabPane label="车辆基本信息1">
          <Form ref="loginForm" :model="installOrder.tempVehicleInfo" :rules="rules">
            <Row>
              <Col span="8">
                <FormItem prop="servicePassword">
                  <label>服务密码</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.servicePassword" placeholder="请输入服务密码">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleLicenseDistributeDatetime">
                  <label>行驶证发证日期</label>
                  <DatePicker :disabled="!modify" type="date" v-model="installOrder.tempVehicleInfo.vehicleLicenseDistributeDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleLicenseReigsterDatetime">
                  <label>行驶证注册日期</label>
                  <DatePicker :disabled="!modify" type="date" v-model="installOrder.tempVehicleInfo.vehicleLicenseReigsterDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="certificateNum">
                  <label>合格证编号</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.certificateNum" placeholder="请输入合格证编号">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="certificateDistributeDatetime">
                  <label>合格证发证日期</label>
                  <DatePicker :disabled="!modify" class="field" style="width: 60%;" type="date"
                              v-model="installOrder.tempVehicleInfo.certificateDistributeDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vehicleModelName">
                  <label>车辆型号</label>
                  <Select :disabled="!modify"
                          placeholder="请输入车辆型号名称"
                          v-model="installOrder.tempVehicleInfo.vehicleModel.name"
                          filterable
                          remote
                          :remote-method="searchVehicleModel"
                          :loading="searchVehicleModelLoading"
                          class="field"
                          clearable>
                    <Option v-for="(option, index) in searchVehicleModelList" :value="option.name" :key="option.name">{{option.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="chassisModel">
                  <label>底盘型号</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.chassisModel" placeholder="请输入底盘型号">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="chassisId">
                  <label>底盘ID</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.chassisId" placeholder="请输入底盘ID">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="chassisCertificateNum">
                  <label>底盘合格证编号</label>
                  <Input :disabled="!modify" class="field" style="width: 60%;" v-model="installOrder.tempVehicleInfo.chassisCertificateNum"
                         placeholder="请输入底盘合格证编号">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="engineModel">
                  <label>发动机型号</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.engineModel" placeholder="请输入发动机型号">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="energyType">
                  <label>发动机类型</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.energyType" placeholder="请输入发动机类型">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="displacement">
                  <label>能耗</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.displacement" placeholder="请输入能耗">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="engineModel">
                  <label>发动机型号</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.engineModel" placeholder="请输入发动机型号">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="energyType">
                  <label>发动机类型</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.energyType" placeholder="请输入发动机类型">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="displacement">
                  <label>排量(ml)</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.displacement" placeholder="请输入排量">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="power">
                  <label>功率(kW)</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.power" placeholder="请输入功率">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="energyUsage">
                  <label>能耗</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.energyUsage" placeholder="请输入能耗">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="emissionStandard">
                  <label>排放标准</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.emissionStandard" placeholder="请输入排放标准">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="manufacturer">
                  <label>制造商名称</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.manufacturer" placeholder="请输入制造商名称">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="springPieceCount">
                  <label>钢板弹簧片数</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.springPieceCount" placeholder="请输入钢板弹簧片数">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="turnType">
                  <label>转向形式</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.turnType" placeholder="请输入转向形式">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="outlineSizeLong">
                  <label>外廓尺寸长(mm)</label>
                  <InputNumber :disabled="!modify" class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.outlineSizeLong"
                               placeholder="请输入外廓尺寸长"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="outlineSizeWidth">
                  <label>外廓尺寸宽(mm)</label>
                  <InputNumber :disabled="!modify" class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.outlineSizeWidth"
                               placeholder="请输入外廓尺寸宽"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="outlineSizeHeight">
                  <label>外廓尺寸高(mm)</label>
                  <InputNumber :disabled="!modify" class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.outlineSizeHeight"
                               placeholder="请输入外廓尺寸高"></InputNumber>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="boxSizeLong">
                  <label>货厢内部尺寸长(mm)</label>
                  <InputNumber :disabled="!modify" class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.boxSizeLong"
                               placeholder="请输入货厢内部尺寸长"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="boxSizeWidth">
                  <label>货厢内部尺寸宽(mm)</label>
                  <InputNumber :disabled="!modify" class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.boxSizeWidth"
                               placeholder="请输入货厢内部尺寸宽"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="boxSizeHeight">
                  <label>货厢内部尺寸高(mm)</label>
                  <InputNumber :disabled="!modify" class="field" style="width: 60%;" :min="0" v-model="installOrder.tempVehicleInfo.boxSizeHeight"
                               placeholder="请输入货厢内部尺寸高"></InputNumber>
                </FormItem>
              </Col>
            </Row>

          </Form>
        </TabPane>
        <TabPane label="车辆基本信息2">
          <Form ref="loginForm" :model="installOrder" :rules="rules">
            <Row>
              <Col span="8">
                <FormItem prop="tyreCount">
                  <label>轮胎数量</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.tyreCount" placeholder="请输入轮胎数量">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="tyreSpec">
                  <label>轮胎规格</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.tyreSpec" placeholder="请输入轮胎规格">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="wheelSpanFront">
                  <label>前轮距</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.wheelSpanFront" placeholder="请输入前轮距">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="wheelSpanBack">
                  <label>后轮距</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.wheelSpanBack" placeholder="请输入后轮距">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="wheelBase">
                  <label>轴距</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.wheelBase" placeholder="请输入轴距">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="axisLoad">
                  <label>轴荷(kg)</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.axisLoad" placeholder="请输入轴荷">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="axisCount">
                  <label>轴数</label>
                  <Input :disabled="!modify" class="field" v-model="installOrder.tempVehicleInfo.axisCount" placeholder="请输入轴数">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="totalMass">
                  <label>总质量(kg)</label>
                  <InputNumber :disabled="!modify" :min="0" class="field" v-model="installOrder.tempVehicleInfo.totalMass" placeholder="请输入总质量">
                  </InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="approvedLoadCoefficient">
                  <label>载质量利用系数</label>
                  <Input :disabled="!modify" class="field" style="width: 50%;" v-model="installOrder.tempVehicleInfo.approvedLoadCoefficient"
                         placeholder="请输入载质量利用系数">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="towMax">
                  <label>准牵引总质量(kg)</label>
                  <InputNumber :disabled="!modify" :min="0" style="width: 30%;" class="field" v-model="installOrder.tempVehicleInfo.towMax"
                               placeholder="请输入准牵引总质量">
                  </InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="saddleMax">
                  <label>半挂车鞍座最大允许总质量(kg)</label>
                  <InputNumber :disabled="!modify" :min="0" class="field" style="width: 30%;" v-model="installOrder.tempVehicleInfo.saddleMax"
                               placeholder="请输入半挂车鞍座最大允许总质量">
                  </InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="cabPeopleCount">
                  <label>驾驶室准乘人数(人)</label>
                  <InputNumber :disabled="!modify" :min="0" class="field" style="width: 50%;" v-model="installOrder.tempVehicleInfo.cabPeopleCount"
                               placeholder="请输入驾驶室准乘人数">
                  </InputNumber>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="mannedCount">
                  <label>额定载客(人)</label>
                  <InputNumber :disabled="!modify" :min="0" class="field" v-model="installOrder.tempVehicleInfo.mannedCount" placeholder="请输入额定载客">
                  </InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="speedMax">
                  <label>最高设计车速(km/h)</label>
                  <InputNumber :disabled="!modify" :min="0" style="width: 40%;" class="field" v-model="installOrder.tempVehicleInfo.speedMax"
                               placeholder="请输入最高设计车速">
                  </InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="productionDatetime">
                  <label>车辆制造日期</label>
                  <DatePicker :disabled="!modify" type="date" v-model="installOrder.tempVehicleInfo.productionDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem prop="certificateRemark">
                  <label>合格证备注</label>
                  <Input :disabled="!modify" class="field" style="width: 80%;" v-model="installOrder.tempVehicleInfo.certificateRemark" type="textarea"
                         placeholder="请输入合格证备注">
                  </Input>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </TabPane>
      </Tabs>
      <Row style="text-align: right;">
        <!--<Button v-if="installOrder.tempVehicleInfo.certificatePictureId" type="default" @click="onAnalyzeCertificatePicture" style="margin-right: 5px;">识别车辆合格证</Button>-->
        <Button v-if="installOrder.tempVehicleInfo.vehicleLicensePictureId" :disabled="analyzing" type="default" @click="onAnalyzeVehicleLicensePicture" style="margin-right: 5px;">识别车辆行驶证</Button>
        <i-switch v-model="modify" @on-change="modifyChange" size="large">
          <span slot="open">保存</span>
          <span slot="close">修改</span>
        </i-switch>
      </Row>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
<!--    </div>-->
    <add-client-info-modal v-model="addClientInfoModal" @on-success="onSuccess"></add-client-info-modal>
    <add-vehicle-info-group-noparent-modal v-model="addVehicleInfoGroupNoparentModal" :parentGroupId="addVehicleInfoGroupParentId"></add-vehicle-info-group-noparent-modal>
    <add-vehicle-owner-info-modal v-model="addVehicleOwnerInfoModal" @on-success="onSuccess"></add-vehicle-owner-info-modal>
  </Modal>
</template>
<script>

import AddClientInfoModal from '@/view/crm/components/add-client-info-modal'
import AddVehicleInfoGroupNoparentModal from '@/view/crm/components/add-vehicle-info-group-noparent-modal'
import AddVehicleOwnerInfoModal from '@/view/crm/components/add-vehicle-owner-info-modal'

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'installorderdetailmodal',
  components: {
    AddClientInfoModal,
    AddVehicleInfoGroupNoparentModal,
    AddVehicleOwnerInfoModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {

      dataLoading: false,

      modify: false,

      analyzing: false,

      // 添加车辆所有人
      addVehicleOwnerInfoModal: false,

      // 添加客户信息
      addClientInfoModal: false,

      // 添加车辆分组
      addVehicleInfoGroupNoparentModal: false,
      addVehicleInfoGroupParentId: null,

      searchSalesChannelValue: null,
      searchSalesChannelLoading: false,
      searchSalesChannelList: [],

      searchVehicleInfoGroupValue: null,
      searchVehicleInfoGroupLoading: false,
      searchVehicleInfoGroupList: [],

      initVehicleModel: null,
      searchVehicleModelLoading: false,
      searchVehicleModelList: [],
      initClientInfo: null,
      searchClientInfoLoading: false,
      searchClientInfoList: [],
      searchClientInfoValue: null,
      initVehicleOwnerInfo: null,
      searchVehicleOwnerInfoValue: null,
      searchVehicleOwnerInfoLoading: false,
      searchVehicleOwnerInfoList: [],
      initVehicleType: null,
      searchVehicleTypeLoading: false,
      searchVehicleTypeList: [],
      initVehicleBrand: null,
      searchVehicleBrandLoading: false,
      searchVehicleBrandList: [],

      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ],

      qghyptOptions: [
        { label: '不需上传', value: 0 },
        { label: '新车上传', value: 1 },
        { label: '旧车转网', value: 2 }
      ],

      orderTypeOptions: [
        { label: '自费安装模式', value: 1 },
        { label: '普通免费模式', value: 2 },
        { label: '太好保模式', value: 3 }
      ],

      // 交强险选择
      searchMLIFTAinsuranceChannelList: [],
      searchMLIFTAinsuranceChannelLoading: false,

      // 商业险选择
      searchTIinsuranceChannelList: [],
      searchTIinsuranceChannelLoading: false,

      installOrderBusinessType: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 },
        { label: '在网升级', value: 3 }
      ],

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        { label: '黑色', value: 3 },
        { label: '白色', value: 4 },
        { label: '渐变绿色', value: 5 },
        { label: '黄绿色', value: 6 },
      ],

      businessUsers: [],
      installers: [],
      installOrder: {
        id: null,
        totalAmount: null,
        serviceDatetime: null,
        businessUserId: null,
        businessType: null,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        history: null,
        installerId: null,
        installer: null,
        remark: null,
        billType: 1,
        isfree: null,
        vehicleInfoGroupId: null,
        tempVehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            name: null
          },
          vehicleBrand: {
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          identificationCode: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        salesChannelId: null,
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        },
        bookingDatetime: null,
        bookingPlace: null,
        actualDatetime: null,
        actualPlace: null
      }
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_GetDetail',
      'InstallOrderServ_ModifyObj',
      'VehicleInfoServ_AnalyzeCertificatePicture',
      'VehicleInfoServ_AnalyzeVehicleLicensePicture'
    ]),
    // onAnalyzeCertificatePicture(){
    //   console.log('onAnalyzeCertificatePicture')
    //   store.dispatch('VehicleInfoServ_AnalyzeCertificatePicture', {
    //     params: {id: this._initValue},
    //     urlparams: null
    //   }).then(() => {
    //     this.$Message.success('分析完成')
    //     let vehicleInfoId = this.installOrder.tempVehicleInfo.id
    //     store.dispatch('VehicleInfoServ_GetDetail', {
    //       params: {id: vehicleInfoId}
    //     }).then(() => {
    //       this.updateInfo(store.getters.get_VehicleInfo_GetDetailResult)
    //     }).catch(err => {
    //       this.$Message.error(err)
    //     })
    //   }).catch(err => {
    //     this.$Message.error(err)
    //   })
    // },
    onAddVehicleOwnerInfoBtn () {
      this.addVehicleOwnerInfoModal = true
    },
    onAnalyzeVehicleLicensePicture () {
      console.log('onAnalyzeVehicleLicensePicture')
      this.analyzing = true
      store.dispatch('InstallOrderServ_AnalyzeVehicleLicensePicture', {
        params: { id: this._initValue },
        urlparams: null
      }).then(() => {
        this.$Message.success('分析完成')
        let installOrderId = this._initValue
        store.dispatch('InstallOrderServ_GetDetail', {
          params: { id: installOrderId }
        }).then(() => {
          this.updateInfo(store.getters.get_InstallOrder_GetDetailResult)
          this.analyzing = false
        }).catch(err => {
          this.analyzing = false
          this.$Message.error(err)
        })
      }).catch(err => {
        this.analyzing = false
        this.$Message.error(err)
      })
    },
    onAddClientInfoGroupBtn () {
      this.addVehicleInfoGroupNoparentModal = true
    },
    onSuccess () {

    },
    searchVehicleType (input) {
      this.searchVehicleTypeLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleTypeList = []
        this.searchVehicleTypeLoading = false
      } else {
        store.dispatch('VehicleTypeServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleTypeList = store.getters.get_VehicleType_SearchByNameResult ? store.getters.get_VehicleType_SearchByNameResult : []
          this.searchVehicleTypeLoading = false
        }).catch(err => {
          this.searchVehicleTypeLoading = false
        })
      }
    },
    searchVehicleBrand (input) {
      this.searchVehicleBrandLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleBrandList = []
        this.searchVehicleBrandLoading = false
      } else {
        store.dispatch('VehicleBrandServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleBrandList = store.getters.get_VehicleBrand_SearchByNameResult ? store.getters.get_VehicleBrand_SearchByNameResult : []
          this.searchVehicleBrandLoading = false
        }).catch(err => {
          this.searchVehicleBrandLoading = false
        })
      }
    },
    searchVehicleOwnerInfo (input) {
      console.log(input)
      this.searchVehicleOwnerInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleOwnerInfoList = []
        this.searchVehicleOwnerInfoLoading = false
      } else {
        store.dispatch('VehicleOwnerInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleOwnerInfoList = store.getters.get_VehicleOwnerInfo_SearchByNameResult ? store.getters.get_VehicleOwnerInfo_SearchByNameResult : []
          this.searchVehicleOwnerInfoLoading = false
        }).catch(err => {
          this.searchVehicleOwnerInfoLoading = false
        })
      }
    },
    searchClientInfo (input) {
      console.log(input)
      console.log('searchClientInfo')
      this.searchClientInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchClientInfoList = []
        this.searchClientInfoLoading = false
      } else {
        store.dispatch('ClientInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchClientInfoList = store.getters.get_ClientInfo_SearchByNameResult ? store.getters.get_ClientInfo_SearchByNameResult : []
          this.searchClientInfoLoading = false
        }).catch(err => {
          this.searchClientInfoLoading = false
        })
      }
    },
    searchVehicleInfoGroup (input) {
      this.searchVehicleInfoGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoGroupList = []
        this.searchVehicleInfoGroupLoading = false
      } else {
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
          this.searchVehicleInfoGroupLoading = false
        }).catch(err => {
          this.searchVehicleInfoGroupLoading = false
        })
      }
    },
    searchSalesChannel (input) {
      console.log(input)
      this.searchSalesChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchSalesChannelList = []
        this.searchSalesChannelLoading = false
      } else {
        store.dispatch('SalesChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchSalesChannelList = store.getters.get_SalesChannel_SearchByNameResult ? store.getters.get_SalesChannel_SearchByNameResult : []
          this.searchSalesChannelLoading = false
        }).catch(err => {
          this.searchSalesChannelLoading = false
        })
      }
    },
    searchVehicleModel (input) {
      this.searchVehicleModelLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleModelList = []
        this.searchVehicleModelLoading = false
      } else {
        store.dispatch('VehicleModelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleModelList = store.getters.get_VehicleModel_SearchByNameResult ? store.getters.get_VehicleModel_SearchByNameResult : []
          this.searchVehicleModelLoading = false
        }).catch(err => {
          this.searchVehicleModelLoading = false
        })
      }
    },
    searchMLIFTAinsuranceChannel (input) {
      this.searchMLIFTAinsuranceChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchMLIFTAinsuranceChannelList = []
        this.searchMLIFTAinsuranceChannelLoading = false
      } else {
        store.dispatch('InsuranceChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchMLIFTAinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
          this.searchMLIFTAinsuranceChannelLoading = false
        }).catch(err => {
          this.searchMLIFTAinsuranceChannelLoading = false
        })
      }
    },
    searchTIinsuranceChannel (input) {
      this.searchTIinsuranceChannelLoading = true
      if (!input || input.length <= 0) {
        this.searchTIinsuranceChannelList = []
        this.searchTIinsuranceChannelLoading = false
      } else {
        store.dispatch('InsuranceChannelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchTIinsuranceChannelList = store.getters.get_InsuranceChannel_SearchByNameResult ? store.getters.get_InsuranceChannel_SearchByNameResult : []
          this.searchTIinsuranceChannelLoading = false
        }).catch(err => {
          this.searchTIinsuranceChannelLoading = false
        })
      }
    },
    modifyChange (status) {
      if (status === false) {
        if (this.installOrder.tempVehicleInfo.vehicleType.name == null) {
          this.$Message.error('请输入车辆类型')
          return
        }
        if (this.installOrder.receptDatetime == '是') {
          this.installOrder.receptDatetime = new Date()
        } else {
          this.installOrder.receptDatetime = null
        }
        if (this.installOrder.urgent == '是') {
          this.installOrder.urgent = true
        } else {
          this.installOrder.urgent = false
        }
        this.$Modal.confirm({
          title: '确认修改安装订单',
          content: '<p>确认修改安装订单</p>',
          onOk: () => {
            store.dispatch('InstallOrderServ_ModifyObj', { params: this.installOrder }).then(() => {
              this.$Message.success('确认修改安装订单')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
              let installOrderId = this._initValue
              store.dispatch('InstallOrderServ_GetDetail', {
                params: { id: installOrderId }
              }).then(() => {
                this.updateInfo(store.getters.get_InstallOrder_GetDetailResult)
              }).catch(err => {
                this.$Message.error(err)
              })
            })
          },
          onCancel: () => {
            let installOrderId = this._initValue
            store.dispatch('InstallOrderServ_GetDetail', {
              params: { id: installOrderId }
            }).then(() => {
              this.updateInfo(store.getters.get_InstallOrder_GetDetailResult)
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.dataLoading = true
        this.modify = false
        this.cleanData()
        let installOrderId = this._initValue
        if (installOrderId) {
          store.dispatch('InstallOrderServ_GetDetail', {
            params: { id: installOrderId }
          }).then(() => {
            this.updateInfo(store.getters.get_InstallOrder_GetDetailResult)
            this.dataLoading = false
          }).catch(err => {
            this.$Message.error(err)
            this.dataLoading = false
          })
        }

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          this.businessUsers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8, 14] }
        }).then(() => {
          this.installers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    cleanData () {
      this.installOrder.id = null
      this.installOrder.totalAmount = null
      this.installOrder.serviceDatetime = null
      this.installOrder.businessUserId = null
      this.installOrder.businessType = null
      this.installOrder.multiDevices = false
      this.installOrder.qghyptOption = 0
      this.installOrder.history = null
      this.installOrder.installerId = null
      this.installOrder.installer = null
      this.installOrder.remark = null
      this.installOrder.clientInfoId = null
      this.installOrder.vehicleInfoGroupId = null
      this.installOrder.billType = 1
      this.installOrder.salesChannelId = null
      this.installOrder.tempVehicleInfo.customName = null
      this.installOrder.tempVehicleInfo.registrationNum = null
      this.installOrder.tempVehicleInfo.registrationColor = null
      this.installOrder.tempVehicleInfo.vin = null
      this.installOrder.tempVehicleInfo.bodyColor = null
      this.installOrder.tempVehicleInfo.vehicleType.name = null
      this.installOrder.tempVehicleInfo.vehicleBrand.name = null
      this.installOrder.tempVehicleInfo.engineNum = null
      this.installOrder.tempVehicleInfo.vehicleLicenseNum = null
      this.installOrder.tempVehicleInfo.unladenMass = null
      this.installOrder.tempVehicleInfo.approvedLoad = null
      this.installOrder.tempVehicleInfo.vehicleOwnerInfoId = null
      this.installOrder.tempVehicleInfo.clientInfoId = null
      this.installOrder.tempVehicleInfo.servicePassword = null
      this.installOrder.tempVehicleInfo.vehicleLicenseDistributeDatetime = null
      this.installOrder.tempVehicleInfo.vehicleLicenseReigsterDatetime = null
      this.installOrder.tempVehicleInfo.remark = null
      this.installOrder.tempVehicleInfo.certificateNum = null
      this.installOrder.tempVehicleInfo.certificateDistributeDatetime = null
      this.installOrder.tempVehicleInfo.vehicleModel.name = null
      this.installOrder.tempVehicleInfo.chassisModel = null
      this.installOrder.tempVehicleInfo.chassisId = null
      this.installOrder.tempVehicleInfo.chassisCertificateNum = null
      this.installOrder.tempVehicleInfo.engineModel = null
      this.installOrder.tempVehicleInfo.energyType = null
      this.installOrder.tempVehicleInfo.displacement = null
      this.installOrder.tempVehicleInfo.power = null
      this.installOrder.tempVehicleInfo.energyUsage = null
      this.installOrder.tempVehicleInfo.emissionStandard = null
      this.installOrder.tempVehicleInfo.manufacturer = null
      this.installOrder.tempVehicleInfo.outlineSizeLong = null
      this.installOrder.tempVehicleInfo.outlineSizeWidth = null
      this.installOrder.tempVehicleInfo.outlineSizeHeight = null
      this.installOrder.tempVehicleInfo.boxSizeLong = null
      this.installOrder.tempVehicleInfo.boxSizeWidth = null
      this.installOrder.tempVehicleInfo.boxSizeHeight = null
      this.installOrder.tempVehicleInfo.springPieceCount = null
      this.installOrder.tempVehicleInfo.tyreCount = null
      this.installOrder.tempVehicleInfo.tyreSpec = null
      this.installOrder.tempVehicleInfo.wheelSpanFront = null
      this.installOrder.tempVehicleInfo.wheelSpanBack = null
      this.installOrder.tempVehicleInfo.wheelBase = null
      this.installOrder.tempVehicleInfo.axisLoad = null
      this.installOrder.tempVehicleInfo.axisCount = null
      this.installOrder.tempVehicleInfo.turnType = null
      this.installOrder.tempVehicleInfo.totalMass = null
      this.installOrder.tempVehicleInfo.approvedLoadCoefficient = null
      this.installOrder.tempVehicleInfo.towMax = null
      this.installOrder.tempVehicleInfo.saddleMax = null
      this.installOrder.tempVehicleInfo.cabPeopleCount = null
      this.installOrder.tempVehicleInfo.mannedCount = null
      this.installOrder.tempVehicleInfo.speedMax = null
      this.installOrder.tempVehicleInfo.productionDatetime = null
      this.installOrder.tempVehicleInfo.certificateRemark = null
      this.installOrder.tempVehicleInfo.vehicleLicensePictureId = null
      this.installOrder.tempVehicleInfo.certificatePictureId = null
      this.installOrder.tempVehicleInfo.vehicleSrcLicensePicture1Id = null
      this.installOrder.tempVehicleInfo.vehicleSrcLicensePicture2Id = null
      this.installOrder.tempVehicleInfo.vehicleBodyPictureId = null
      this.installOrder.tempVehicleInfo.test = false
      this.installOrder.tempVehicleInfo.vehicleUse = null
      this.installOrder.tempVehicleInfo.attention = false
      this.installOrder.tempVehicleInfo.identificationCode = null
    },
    updateInfo (existInstallOrder) {
      this.installOrder.id = existInstallOrder.id
      this.installOrder.totalAmount = existInstallOrder.totalAmount
      this.installOrder.serviceDatetime = existInstallOrder.serviceDatetime === null ? null : new Date(existInstallOrder.serviceDatetime)
      this.installOrder.businessUserId = existInstallOrder.businessUserId
      this.installOrder.businessType = existInstallOrder.businessType
      this.installOrder.multiDevices = existInstallOrder.multiDevices
      this.installOrder.qghyptOption = existInstallOrder.qghyptOption
      this.installOrder.history = existInstallOrder.history
      this.installOrder.installerId = existInstallOrder.installerId
      this.installOrder.installer = existInstallOrder.installer
      this.installOrder.remark = existInstallOrder.remark
      this.installOrder.billType = existInstallOrder.billType
      this.installOrder.salesChannelId = existInstallOrder.salesChannelId
      this.installOrder.isfree = existInstallOrder.isfree
      this.installOrder.tempVehicleInfo.id = existInstallOrder.tempVehicleInfo.id
      this.installOrder.tempVehicleInfo.customName = existInstallOrder.tempVehicleInfo.customName
      this.installOrder.tempVehicleInfo.registrationNum = existInstallOrder.tempVehicleInfo.registrationNum
      this.installOrder.tempVehicleInfo.registrationColor = existInstallOrder.tempVehicleInfo.registrationColor
      this.installOrder.tempVehicleInfo.vin = existInstallOrder.tempVehicleInfo.vin
      this.installOrder.tempVehicleInfo.bodyColor = existInstallOrder.tempVehicleInfo.bodyColor
      this.installOrder.tempVehicleInfo.vehicleType.name = existInstallOrder.tempVehicleInfo.vehicleType === null ? null : existInstallOrder.tempVehicleInfo.vehicleType.name
      this.installOrder.tempVehicleInfo.vehicleBrand.name = existInstallOrder.tempVehicleInfo.vehicleBrand === null ? null : existInstallOrder.tempVehicleInfo.vehicleBrand.name
      this.installOrder.tempVehicleInfo.engineNum = existInstallOrder.tempVehicleInfo.engineNum
      this.installOrder.tempVehicleInfo.vehicleLicenseNum = existInstallOrder.tempVehicleInfo.vehicleLicenseNum
      this.installOrder.tempVehicleInfo.unladenMass = existInstallOrder.tempVehicleInfo.unladenMass
      this.installOrder.tempVehicleInfo.approvedLoad = existInstallOrder.tempVehicleInfo.approvedLoad
      // this.installOrder.tempVehicleInfo.vehicleOwnerInfoId = existInstallOrder.tempVehicleInfo.vehicleOwnerInfoId
      this.installOrder.tempVehicleInfo.servicePassword = existInstallOrder.tempVehicleInfo.servicePassword
      this.installOrder.tempVehicleInfo.vehicleLicenseDistributeDatetime = existInstallOrder.tempVehicleInfo.vehicleLicenseDistributeDatetime === null ? null : new Date(existInstallOrder.tempVehicleInfo.vehicleLicenseDistributeDatetime)
      this.installOrder.tempVehicleInfo.vehicleLicenseReigsterDatetime = existInstallOrder.tempVehicleInfo.vehicleLicenseReigsterDatetime === null ? null : new Date(existInstallOrder.tempVehicleInfo.vehicleLicenseReigsterDatetime)
      this.installOrder.tempVehicleInfo.remark = existInstallOrder.tempVehicleInfo.remark
      this.installOrder.tempVehicleInfo.certificateNum = existInstallOrder.tempVehicleInfo.certificateNum
      this.installOrder.tempVehicleInfo.certificateDistributeDatetime = existInstallOrder.tempVehicleInfo.certificateDistributeDatetime === null ? null : new Date(existInstallOrder.tempVehicleInfo.certificateDistributeDatetime)
      this.installOrder.tempVehicleInfo.vehicleModel.name = existInstallOrder.tempVehicleInfo.vehicleModel === null ? null : existInstallOrder.tempVehicleInfo.vehicleModel.name
      this.installOrder.tempVehicleInfo.chassisModel = existInstallOrder.tempVehicleInfo.chassisModel
      this.installOrder.tempVehicleInfo.chassisId = existInstallOrder.tempVehicleInfo.chassisId
      this.installOrder.tempVehicleInfo.chassisCertificateNum = existInstallOrder.tempVehicleInfo.chassisCertificateNum
      this.installOrder.tempVehicleInfo.engineModel = existInstallOrder.tempVehicleInfo.engineModel
      this.installOrder.tempVehicleInfo.energyType = existInstallOrder.tempVehicleInfo.energyType
      this.installOrder.tempVehicleInfo.displacement = existInstallOrder.tempVehicleInfo.displacement
      this.installOrder.tempVehicleInfo.power = existInstallOrder.tempVehicleInfo.power
      this.installOrder.tempVehicleInfo.energyUsage = existInstallOrder.tempVehicleInfo.energyUsage
      this.installOrder.tempVehicleInfo.emissionStandard = existInstallOrder.tempVehicleInfo.emissionStandard
      this.installOrder.tempVehicleInfo.manufacturer = existInstallOrder.tempVehicleInfo.manufacturer
      this.installOrder.tempVehicleInfo.outlineSizeLong = existInstallOrder.tempVehicleInfo.outlineSizeLong
      this.installOrder.tempVehicleInfo.outlineSizeWidth = existInstallOrder.tempVehicleInfo.outlineSizeWidth
      this.installOrder.tempVehicleInfo.outlineSizeHeight = existInstallOrder.tempVehicleInfo.outlineSizeHeight
      this.installOrder.tempVehicleInfo.boxSizeLong = existInstallOrder.tempVehicleInfo.boxSizeLong
      this.installOrder.tempVehicleInfo.boxSizeWidth = existInstallOrder.tempVehicleInfo.boxSizeWidth
      this.installOrder.tempVehicleInfo.boxSizeHeight = existInstallOrder.tempVehicleInfo.boxSizeHeight
      this.installOrder.tempVehicleInfo.springPieceCount = existInstallOrder.tempVehicleInfo.springPieceCount
      this.installOrder.tempVehicleInfo.tyreCount = existInstallOrder.tempVehicleInfo.tyreCount
      this.installOrder.tempVehicleInfo.tyreSpec = existInstallOrder.tempVehicleInfo.tyreSpec
      this.installOrder.tempVehicleInfo.wheelSpanFront = existInstallOrder.tempVehicleInfo.wheelSpanFront
      this.installOrder.tempVehicleInfo.wheelSpanBack = existInstallOrder.tempVehicleInfo.wheelSpanBack
      this.installOrder.tempVehicleInfo.wheelBase = existInstallOrder.tempVehicleInfo.wheelBase
      this.installOrder.tempVehicleInfo.axisLoad = existInstallOrder.tempVehicleInfo.axisLoad
      this.installOrder.tempVehicleInfo.axisCount = existInstallOrder.tempVehicleInfo.axisCount
      this.installOrder.tempVehicleInfo.axisCount = existInstallOrder.tempVehicleInfo.axisCount
      this.installOrder.tempVehicleInfo.totalMass = existInstallOrder.tempVehicleInfo.totalMass
      this.installOrder.tempVehicleInfo.approvedLoadCoefficient = existInstallOrder.tempVehicleInfo.approvedLoadCoefficient
      this.installOrder.tempVehicleInfo.towMax = existInstallOrder.tempVehicleInfo.towMax
      this.installOrder.tempVehicleInfo.saddleMax = existInstallOrder.tempVehicleInfo.saddleMax
      this.installOrder.tempVehicleInfo.cabPeopleCount = existInstallOrder.tempVehicleInfo.cabPeopleCount
      this.installOrder.tempVehicleInfo.mannedCount = existInstallOrder.tempVehicleInfo.mannedCount
      this.installOrder.tempVehicleInfo.speedMax = existInstallOrder.tempVehicleInfo.speedMax
      this.installOrder.tempVehicleInfo.productionDatetime = existInstallOrder.tempVehicleInfo.productionDatetime === null ? null : new Date(existInstallOrder.tempVehicleInfo.productionDatetime)
      this.installOrder.tempVehicleInfo.certificateRemark = existInstallOrder.tempVehicleInfo.certificateRemark
      this.installOrder.tempVehicleInfo.vehicleLicensePictureId = existInstallOrder.tempVehicleInfo.vehicleLicensePictureId
      this.installOrder.tempVehicleInfo.certificatePictureId = existInstallOrder.tempVehicleInfo.certificatePictureId
      this.installOrder.tempVehicleInfo.vehicleSrcLicensePicture1Id = existInstallOrder.tempVehicleInfo.vehicleSrcLicensePicture1Id
      this.installOrder.tempVehicleInfo.vehicleSrcLicensePicture2Id = existInstallOrder.tempVehicleInfo.vehicleSrcLicensePicture2Id
      this.installOrder.tempVehicleInfo.vehicleBodyPictureId = existInstallOrder.tempVehicleInfo.vehicleBodyPictureId
      this.installOrder.tempVehicleInfo.vehicleUse = existInstallOrder.tempVehicleInfo.vehicleUse
      this.installOrder.tempVehicleInfo.attention = existInstallOrder.tempVehicleInfo.attention
      this.installOrder.tempVehicleInfo.identificationCode = existInstallOrder.tempVehicleInfo.identificationCode
      this.installOrder.tempVehicleInfo.mliftainsuranceChannelId = existInstallOrder.tempVehicleInfo.mliftainsuranceChannelId
      this.installOrder.tempVehicleInfo.mliftainsurancechannelDatetime = existInstallOrder.tempVehicleInfo.mliftainsurancechannelDatetime === null ? null : new Date(existInstallOrder.tempVehicleInfo.mliftainsurancechannelDatetime)
      this.installOrder.tempVehicleInfo.tiinsuranceChannelId = existInstallOrder.tempVehicleInfo.tiinsuranceChannelId
      this.installOrder.tempVehicleInfo.tiinsurancechannelDatetime = existInstallOrder.tempVehicleInfo.tiinsurancechannelDatetime === null ? null : new Date(existInstallOrder.tempVehicleInfo.tiinsurancechannelDatetime)
      this.installOrder.tempVehicleInfo.insured = existInstallOrder.tempVehicleInfo.insured
      if (existInstallOrder.urgent) {
        this.installOrder.urgent = '是'
      } else {
        this.installOrder.urgent = '否'
      }
      if (existInstallOrder.receptDatetime) {
        this.installOrder.receptDatetime = '是'
      } else {
        this.installOrder.receptDatetime = '否'
      }
      this.installOrder.stepId = existInstallOrder.stepId
      this.installOrder.step = existInstallOrder.step
      this.installOrder.bookingDatetime = new Date(existInstallOrder.bookingDatetime)
      this.installOrder.bookingPlace = existInstallOrder.bookingPlace
      this.installOrder.actualDatetime = new Date(existInstallOrder.actualDatetime)
      this.installOrder.actualPlace = existInstallOrder.actualPlace

      store.dispatch('InsuranceChannelServ_GetDetail', {
        params: { id: this.installOrder.tempVehicleInfo.mliftainsuranceChannelId },
        urlparams: null
      }).then(() => {
        this.searchMLIFTAinsuranceChannelList.push(store.getters.get_InsuranceChannel_GetDetailResult)
        this.searchMLIFTAinsuranceChannelLoading = false
      }).catch(err => {
        this.searchMLIFTAinsuranceChannelLoading = false
      })

      store.dispatch('InsuranceChannelServ_GetDetail', {
        params: { id: this.installOrder.tempVehicleInfo.tiinsuranceChannelId },
        urlparams: null
      }).then(() => {
        this.searchTIinsuranceChannelList.push(store.getters.get_InsuranceChannel_GetDetailResult)
        this.searchTIinsuranceChannelLoading = false
      }).catch(err => {
        this.searchTIinsuranceChannelLoading = false
      })

      if (existInstallOrder.tempVehicleInfo.vehicleOwnerInfoId) {
        this.searchVehicleOwnerInfoList = []
        existInstallOrder.tempVehicleInfo.vehicleOwnerInfo.name = existInstallOrder.tempVehicleInfo.vehicleOwnerInfo.name + '(' + existInstallOrder.tempVehicleInfo.vehicleOwnerInfo.address + ')'
        this.searchVehicleOwnerInfoList.push(existInstallOrder.tempVehicleInfo.vehicleOwnerInfo)
        this.searchVehicleOwnerInfoValue = this.searchVehicleOwnerInfo
        console.log(this.searchVehicleOwnerInfoList)
      }

      if (existInstallOrder.clientInfoId) {
        this.searchClientInfoList = []
        existInstallOrder.clientInfo.name = existInstallOrder.clientInfo.name + '(' + existInstallOrder.clientInfo.phoneNum + ')'
        this.searchClientInfoList.push(existInstallOrder.clientInfo)
        this.searchClientInfoValue = this.searchClientInfo
      }

      if (existInstallOrder.vehicleInfoGroupId) {
        this.searchVehicleInfoGroupList = []
        // existInstallOrder.vehicleInfoGroup.name = existInstallOrder.clientInfo.name + '(' + existInstallOrder.clientInfo.phoneNum + ')'
        this.searchVehicleInfoGroupList.push(existInstallOrder.vehicleInfoGroup)
        this.searchVehicleInfoGroupValue = this.searchVehicleInfoGroup
      }

      if (existInstallOrder.salesChannelId) {
        this.searchSalesChannelList = []
        // existInstallOrder.vehicleInfoGroup.name = existInstallOrder.clientInfo.name + '(' + existInstallOrder.clientInfo.phoneNum + ')'
        this.searchSalesChannelList.push(existInstallOrder.salesChannel)
        this.searchSalesChannelValue = this.searchSalesChannel
      }

      if (existInstallOrder.tempVehicleInfo.vehicleModel) {
        this.installOrder.tempVehicleInfo.vehicleModel.name = existInstallOrder.tempVehicleInfo.vehicleModel.name
      }

      if (existInstallOrder.tempVehicleInfo.vehicleType) {
        this.installOrder.tempVehicleInfo.vehicleType.name = existInstallOrder.tempVehicleInfo.vehicleType.name
      }

      if (existInstallOrder.tempVehicleInfo.vehicleBrand) {
        this.installOrder.tempVehicleInfo.vehicleBrand.name = existInstallOrder.tempVehicleInfo.vehicleBrand.name
      }

      store.dispatch('InstallOrderServ_GetDetail', {
        params: { id: this._initValue }
      }).then(() => {
        this.installOrder.clientInfoId = existInstallOrder.clientInfoId
        this.installOrder.salesChannelId = existInstallOrder.salesChannelId
        this.installOrder.vehicleInfoGroupId = existInstallOrder.vehicleInfoGroupId
        this.installOrder.tempVehicleInfo.vehicleOwnerInfoId = existInstallOrder.tempVehicleInfo.vehicleOwnerInfoId
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

  .field {
    margin-left: 5px;
    width: 70%;
  }
</style>
